import { ReactElement } from 'react';
import { KebapMenuItemProps } from './kebap-menu-item';
import styles from './kebap-menu.module.scss';
import classNames from 'classnames';

export type KebapMenuProps<T> = {
  children: Array<ReactElement<KebapMenuItemProps<T>>>;
  isOpen: boolean;
}

export const KebapMenu = <T extends string | number,>({ children, isOpen }: KebapMenuProps<T>) => {
  return (
    <div className={classNames({
      [styles.kebapMenu]: true,
      [styles.isOpen]: isOpen,
    })}>
      {children}
    </div>
  );
};
